import { formatDate } from "@/utils/mixin";
import { uniqueId } from "lodash";
import React, { ChangeEvent } from "react";
import { twMerge } from "tailwind-merge";

interface IInput extends React.HTMLProps<HTMLInputElement> {
  id?: string;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  type?: string;
  label?: any;
  value?: any;
  // eslint-disable-next-line no-unused-vars
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line no-unused-vars
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  readonly?: boolean;
  disabled?: boolean;
  textColor?: string;
}

export const Input = React.forwardRef(
  (
    {
      id = uniqueId(),
      className = "",
      inputClassName = "",
      labelClassName = "",
      placeholder,
      type = "text",
      label,
      value,
      onChange,
      onBlur,
      readonly = false,
      disabled = false,
      textColor = "text-dark-blue",
      required,
      ...props
    }: IInput,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => {
    return (
      <div className={twMerge("flex flex-col items-start", className)}>
        <label className={twMerge("w-full text-gray-500 text-sm", labelClassName)} htmlFor={id}>
          {label}
          {required && <span className="text-red-500"> * </span>}
        </label>

        {!readonly ? (
          <input
            id={id}
            className={twMerge("w-full rounded-md p-2 border ", textColor, inputClassName)}
            placeholder={readonly ? "-" : placeholder}
            type={readonly ? "text" : type}
            value={type === "date" ? formatDate(value, "YYYY-MM-DD") : value}
            onChange={(e) => {
              if (onChange) onChange(e);
            }}
            disabled={disabled}
            onBlur={(e) => {
              if (onBlur) onBlur(e);
            }}
            {...props}
            readOnly={readonly}
            ref={ref}
          />
        ) : (
          <span
            id={id}
            className={twMerge(
              "w-full rounded-md p-2 border disabled:opacity-30 read-only:outline-none read-only:shadow-none read-only:border-none read-only:p-0",
              textColor,
              readonly ? " bg-transparent text-dark-blue" : "",
              inputClassName,
            )}
            {...props}
            ref={ref}
          >
            {type === "date" ? formatDate(value) : value || "-"}
          </span>
        )}
      </div>
    );
  },
);
